import { MONTHLY } from '@constants/billingPeriods'
import { PLN } from '@constants/currencies'
import { convertPriceToNetto } from '@helpers/payment'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'

import { useGetPlansList } from './useGetPlansList'
import { PROMOTION_KEYS, useGetPromotions } from './useGetPromotions'

export const useGetPurchaseSummaryInfo = () => {
  const {
    accountCurrency,
    chosenBillingPeriod,
    getPlanPrice,
    getAnnualSavingPrice,
    getActiveDiscountForPlan,
    checkoutDataInContext: { chosenRecordKey }
  } = useCheckoutContext()

  const discount = chosenRecordKey
    ? getActiveDiscountForPlan(chosenRecordKey)
    : undefined

  const plans = useGetPlansList()
  const planPrefix = chosenRecordKey ? chosenRecordKey.split('_')[0] : ''
  const planName =
    plans.find(plan => plan.recordKey.includes(planPrefix))?.name ?? ''

  const planPricePerMonth = chosenRecordKey ? getPlanPrice(chosenRecordKey) : 0
  const planPriceInMonthlyPeriod = chosenRecordKey
    ? getPlanPrice(chosenRecordKey, MONTHLY)
    : 0

  const promotions = useGetPromotions({
    price: planPricePerMonth,
    billingPeriod: chosenBillingPeriod
  })

  const activePromotionKey = PROMOTION_KEYS.find(
    key => promotions[key].isVisible
  )

  const isPromotionActive = !!activePromotionKey

  const finalPlanPricePerMonth = discount
    ? planPricePerMonth -
      convertPriceToNetto(discount.pricing / discount.period)
    : planPricePerMonth

  const getFinalPrice = () => {
    if (discount) {
      return finalPlanPricePerMonth
    }

    if (isPromotionActive && activePromotionKey) {
      return promotions[activePromotionKey].price ?? 0
    }

    return finalPlanPricePerMonth
  }

  const finalPrice = getFinalPrice()

  const vatAmount =
    accountCurrency === PLN ? finalPrice * 0.23 * chosenBillingPeriod : 0

  const totalPrice = finalPrice * chosenBillingPeriod + vatAmount

  const annualSavingPrice = chosenRecordKey
    ? getAnnualSavingPrice(chosenRecordKey)
    : 0

  return {
    planName,
    planPricePerMonthWithoutDiscount: planPricePerMonth,
    planPricePerMonth: finalPlanPricePerMonth,
    planPriceInMonthlyPeriod,
    finalPrice,
    annualSavingPrice,
    vatAmount,
    totalPrice,
    activePromotionKey,
    discount
  }
}
